export default __webpack_public_path__ + "static/media/UserTwo.0a48b176.svg";